export const LEAD_AR_INTEGRATION_LINK = "https://links.myleadar.com/startplan";
